import initSliders from './components/sliders'
import initNav from './components/navigation'
import { tinymce } from './functions/tinymce'
import { showMoreContent } from './functions/show-more-content'

////////////////////////////////////////////////
// Events
////////////////////////////////////////////////
document.addEventListener("DOMContentLoaded", () => {
	initNav()
	initSliders()
	tinymce()
	showMoreContent();
})
